// src/pages/NotFound/NotFound.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import notFoundImg from "../assets/HomeLatest/404-Error-img.webp";
import "./NotFound.css";

const NotFound = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate("/");
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <img
          src={notFoundImg}
          alt="404 Error"
          className="not-found-image"
        />

        <h1 className="not-found-title">Page Not Found</h1>

        <p className="not-found-message">
          Oops! The page you are looking for doesn't exist or has been moved.
        </p>

        <button
          type="button"
          className="home-btn"
          onClick={goToHome}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;